import React from "react";
import cs from "classnames";
import { useShopContext } from "../../../lib/context/ShopContext/ShopContext";
import {
  Select as MobileSelect,
  SortSelectOption,
} from "../../GeneralFilters/SortSelect/Select";
import { useTranslation } from "react-i18next";
import { actions } from "../../../lib/translation/strings";

import "./ShopFilterActions.scss";

interface Props {
  className?: string;
  btnFilterClassName?: string;

  selectInitialValue?: string;
  selectHidden?: boolean;
  selectClassName?: string;
}

// const desktopSelectOptions: ShopSelectOptions[] = [...sameOptions];

export const ShopFilterActions = (props: Props) => {
  const { t } = useTranslation();
  const shopCtx = useShopContext();

  const sameOptions = [
    { value: "SLUG-ASC", label: t(actions.letterA) },
    { value: "SLUG-DESC", label: t(actions.letterZH) },
    { value: "PRICE-ASC", label: t(actions.lowestPrice) },
    { value: "PRICE-DESC", label: t(actions.highestPrice) },
  ];

  const mobileSelectOptions: SortSelectOption[] = [
    { value: "", label: t(actions.orderBy), isPlaceholder: true },
    ...sameOptions,
  ];

  // const initialOption = desktopSelectOptions.find(
  //   (o) => o.value === shopCtx?.data?.order
  // );
  // const selectedOptions = initialOption
  //   ? [initialOption]
  //   : ([] as ShopSelectOptions[]);

  const hanleMobileSelectChange = (e: string) => {
    if (shopCtx.handlers?.handleOrderChange) {
      shopCtx.handlers.handleOrderChange(e);
    }
  };

  // const handleOnSelect = (selectedOption?: ShopSelectOptions) => {
  //   const value =
  //     selectedOption && selectedOption?.value ? selectedOption.value : "";

  //   if (shopCtx.handlers?.handleOrderChange) {
  //     shopCtx.handlers.handleOrderChange(value);
  //   }
  // };

  return (
    <div className={cs("ShopFilterActions", props.className)}>
      {!props.selectHidden && (
        <>
          <MobileSelect
            value={shopCtx?.data?.order || ""}
            className={cs("ShopFilterActions__btn", props.selectClassName)}
            name="products-order"
            options={mobileSelectOptions}
            onChange={(e) => hanleMobileSelectChange(e as string)}
          />

          {/*<ShopSelect*/}
          {/*  closeOnSelect*/}
          {/*  disableMultiselect*/}
          {/*  showSelectedOption*/}
          {/*  relativeIcon*/}
          {/*  label={t(actions.orderBy)}*/}
          {/*  selected={selectedOptions}*/}
          {/*  options={desktopSelectOptions}*/}
          {/*  onSelect={(selectedOptions) => handleOnSelect(selectedOptions)}*/}
          {/*  className="ShopFilterActions__btn ShopFilterActions__order_desktop"*/}
          {/*/>*/}
        </>
      )}
    </div>
  );
};
